export const FIELD_MAPPINGS = {
  period: 'periodName',
  tagcode: 'tagCode',
  tagdescription: 'tagDescription',
  countrytaxtype: 'countryTaxType',
};

export const MIN_COLUMNS_NUMBER = 4;
export const MAX_COLUMNS_NUMBER = 4;
